var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.2 18.6c-.2 0-.3-.1-.4-.2l-9.1-9c-.2-.2-.2-.6 0-.8s.6-.2.8 0l8.6 8.6 8.2-8.6c.2-.2.6-.2.8 0s.2.6 0 .8l-8.7 9.1c.1.1 0 .1-.2.1"
})));
export default SvgArrowDown;